import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { FilterStateService } from '@services/filter-state.service';
import { SectionHeaderComponent } from '@shared/section-header/section-header.component';
import { IconSanitizerService } from 'ngx-lib';
import { IFilterValueContacts } from '../contacts-filters/contacts-filters/contacts-filter.config';
import { ContactsFiltersComponent } from '../contacts-filters/contacts-filters/contacts-filters.component';
import { ContactsListComponent } from '../contacts-list/contacts-list.component';

@Component({
    selector: 'app-contacts-main',
    templateUrl: './contacts-main.component.html',
    styleUrls: ['./contacts-main.component.scss'],
    imports: [SectionHeaderComponent, ContactsFiltersComponent, ContactsListComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: FilterStateService,
            useClass: FilterStateService<IFilterValueContacts>
        }
    ]
})
export class ContactsMainComponent implements OnInit {
    plusIcon?: SafeHtml;

    private readonly router = inject(Router);
    private readonly iconSanitizer = inject(IconSanitizerService);

    async ngOnInit(): Promise<void> {
        this.plusIcon = this.iconSanitizer.getIcon('plus');
    }

    onCreateNewContactClicked(): void {
        this.router.navigate([`/contacts-edit`]);
    }
}
